// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

table.spreadsheet {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  --mat-table-row-item-container-height: 30px;
}

th {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 60px;
  max-width: 300px;
  padding: 6px 8px;
  font-weight: 600;
  font-size: 11px;
  text-align: left;
  border-bottom: 2px solid var(--preset-border, rgba(128, 128, 128, 0.3));
  border-right: 1px solid var(--preset-border, rgba(128, 128, 128, 0.1));
  background: var(--preset-card, #073642);
  position: sticky;
  top: 0;
  z-index: 1;
}

td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 60px;
  max-width: 300px;
  height: 30px;
  padding: 4px 6px;
  border-width: 2px;
  border-style: solid;
  border-color: transparent var(--preset-border, rgba(128, 128, 128, 0.1)) var(--preset-border, rgba(128, 128, 128, 0.15)) transparent;
  cursor: cell;
  -webkit-user-select: none;
          user-select: none;
  font-family: "Roboto Mono", "Consolas", "Monaco", monospace;
  font-size: 11px;
  box-sizing: border-box;
}
td:hover:not(.selected) {
  background: var(--preset-hover, rgba(128, 128, 128, 0.1));
}
td.selection-top {
  border-top-color: rgba(51, 144, 255, 0.8);
}
td.selection-bottom {
  border-bottom-color: rgba(51, 144, 255, 0.8);
}
td.selection-left {
  border-left-color: rgba(51, 144, 255, 0.8);
}
td.selection-right {
  border-right-color: rgba(51, 144, 255, 0.8);
}
td.selecting {
  cursor: cell;
}

tr.compact:hover td:not(.selected) {
  background: var(--preset-hover, rgba(128, 128, 128, 0.05));
}

.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  gap: 8px;
  color: #ff6b6b;
}
.error-state .error-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  opacity: 0.7;
}
.error-state span {
  font-size: 13px;
}
.error-state .open-editor-btn {
  margin-top: 8px;
  padding: 6px 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  background: transparent;
  color: var(--text-secondary, rgba(255, 255, 255, 0.7));
  font-size: 12px;
  cursor: pointer;
}
.error-state .open-editor-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.container {
  width: 100%;
  height: calc(100% - 56px);
  overflow-x: auto;
  overflow-y: auto;
  scrollbar-width: thin !important;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent !important;
}
.container::-webkit-scrollbar {
  width: 8px !important;
  height: 8px !important;
}
.container::-webkit-scrollbar-track {
  background: transparent !important;
}
.container::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7) !important;
  border-radius: 4px !important;
}
.container::-webkit-scrollbar-thumb:hover {
  background: rgba(155, 155, 155, 0.9) !important;
}
.container::-webkit-scrollbar-corner {
  background: transparent !important;
}

.paginator {
  height: 56px;
  border-top: 1px solid var(--preset-border, rgba(128, 128, 128, 0.15));
}`, "",{"version":3,"sources":["webpack://./src/app/components/data/csv-viewer/csv-viewer.component.scss"],"names":[],"mappings":"AA4BA;EACE,cAAA;EACA,YAAA;AA3BF;;AA8BA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EAGA,2CAAA;AA7BF;;AAgCA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uEAAA;EACA,sEAAA;EACA,uCAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AA7BF;;AAgCA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EAGA,iBAAA;EACA,mBAAA;EACA,oIAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,2DAAA;EACA,eAAA;EACA,sBAAA;AA/BF;AAiCE;EACE,yDAAA;AA/BJ;AAmCE;EACE,yCAAA;AAjCJ;AAoCE;EACE,4CAAA;AAlCJ;AAqCE;EACE,0CAAA;AAnCJ;AAsCE;EACE,2CAAA;AApCJ;AAuCE;EACE,YAAA;AArCJ;;AA0CE;EACE,0DAAA;AAvCJ;;AA2CA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,QAAA;EACA,cAAA;AAxCF;AA0CE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAxCJ;AA2CE;EACE,eAAA;AAzCJ;AA4CE;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,kBAAA;EACA,uBAAA;EACA,sDAAA;EACA,eAAA;EACA,eAAA;AA1CJ;AA4CI;EACE,oCAAA;AA1CN;;AA+CA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EArJA,gCAAA;EACA,gEAAA;AA0GF;AAxGE;EACE,qBAAA;EACA,sBAAA;AA0GJ;AAvGE;EACE,kCAAA;AAyGJ;AAtGE;EACE,+CAAA;EACA,6BAAA;AAwGJ;AAtGI;EACE,+CAAA;AAwGN;AApGE;EACE,kCAAA;AAsGJ;;AA6BA;EACE,YAAA;EACA,qEAAA;AA1BF","sourcesContent":["// Scrollbar styling - use rgba values for reliable cross-theme support\n@mixin themed-scrollbar {\n  scrollbar-width: thin !important;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent !important;\n\n  &::-webkit-scrollbar {\n    width: 8px !important;\n    height: 8px !important;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent !important;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(155, 155, 155, 0.7) !important;\n    border-radius: 4px !important;\n\n    &:hover {\n      background: rgba(155, 155, 155, 0.9) !important;\n    }\n  }\n\n  &::-webkit-scrollbar-corner {\n    background: transparent !important;\n  }\n}\n\n:host {\n  display: block;\n  height: 100%;\n}\n\ntable.spreadsheet {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n\n  // Override Material table row height\n  --mat-table-row-item-container-height: 30px;\n}\n\nth {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 60px;\n  max-width: 300px;\n  padding: 6px 8px;\n  font-weight: 600;\n  font-size: 11px;\n  text-align: left;\n  border-bottom: 2px solid var(--preset-border, rgba(128, 128, 128, 0.3));\n  border-right: 1px solid var(--preset-border, rgba(128, 128, 128, 0.1));\n  background: var(--preset-card, #073642);\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\ntd {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 60px;\n  max-width: 300px;\n  height: 30px;\n  padding: 4px 6px;\n  // Use 2px borders on all sides to prevent jitter during selection\n  // top, right, bottom, left\n  border-width: 2px;\n  border-style: solid;\n  border-color: transparent var(--preset-border, rgba(128, 128, 128, 0.1)) var(--preset-border, rgba(128, 128, 128, 0.15)) transparent;\n  cursor: cell;\n  user-select: none;\n  font-family: 'Roboto Mono', 'Consolas', 'Monaco', monospace;\n  font-size: 11px;\n  box-sizing: border-box;\n\n  &:hover:not(.selected) {\n    background: var(--preset-hover, rgba(128, 128, 128, 0.1));\n  }\n\n  // Selection border - change color on outer edges\n  &.selection-top {\n    border-top-color: rgba(51, 144, 255, 0.8);\n  }\n\n  &.selection-bottom {\n    border-bottom-color: rgba(51, 144, 255, 0.8);\n  }\n\n  &.selection-left {\n    border-left-color: rgba(51, 144, 255, 0.8);\n  }\n\n  &.selection-right {\n    border-right-color: rgba(51, 144, 255, 0.8);\n  }\n\n  &.selecting {\n    cursor: cell;\n  }\n}\n\ntr.compact {\n  &:hover td:not(.selected) {\n    background: var(--preset-hover, rgba(128, 128, 128, 0.05));\n  }\n}\n\n.error-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  gap: 8px;\n  color: #ff6b6b;\n\n  .error-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    opacity: 0.7;\n  }\n\n  span {\n    font-size: 13px;\n  }\n\n  .open-editor-btn {\n    margin-top: 8px;\n    padding: 6px 16px;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 4px;\n    background: transparent;\n    color: var(--text-secondary, rgba(255, 255, 255, 0.7));\n    font-size: 12px;\n    cursor: pointer;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.1);\n    }\n  }\n}\n\n.container {\n  width: 100%;\n  height: calc(100% - 56px);\n  overflow-x: auto;\n  overflow-y: auto;\n  @include themed-scrollbar;\n}\n\n.paginator {\n  height: 56px;\n  border-top: 1px solid var(--preset-border, rgba(128, 128, 128, 0.15));\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
